import { produce } from 'immer'
import { create } from 'zustand'

import { SummaryRequest } from 'types/project'

export type SummaryUIState = {
  summaryIsOpen: boolean
  setSummaryIsOpen: (summaryIsOpen: boolean) => void
  summaryRequest: SummaryRequest | null
  setSummaryRequest: (summaryRequest: SummaryRequest | null) => void
  summaryDebounce: boolean
  setSummaryDebounce: (summaryDebounce: boolean) => void
  resetSummaryUI: () => void
}

const initialState = {
  summaryIsOpen: false,
  summaryRequest: null as SummaryRequest | null,
  summaryDebounce: false,
}

export const useSummaryUIStore = create<SummaryUIState>()((set) => ({
  ...initialState,

  setSummaryIsOpen: (summaryIsOpen) =>
    set(
      produce((s: SummaryUIState) => {
        s.summaryIsOpen = summaryIsOpen
      }),
    ),

  setSummaryRequest: (summaryRequest) =>
    set(
      produce((s: SummaryUIState) => {
        s.summaryRequest = summaryRequest
      }),
    ),

  setSummaryDebounce: (summaryDebounce) =>
    set(
      produce((s: SummaryUIState) => {
        s.summaryDebounce = summaryDebounce
      }),
    ),

  resetSummaryUI: () => set(initialState),
}))
